"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondarySelect = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _creatable = _interopRequireDefault(require("react-select/creatable"));

var _propTypes = require("prop-types");

var _menu = require("./menu");

var _dropdownIndicator = require("./dropdown-indicator");

var _valueContainer = require("./value-container");

var _control = require("./control");

var _styles = require("./styles");

var _excluded = ["theme", "styles", "components", "isCreatable"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var SecondarySelect = function SecondarySelect(props) {
  var themeProp = props.theme,
      stylesProp = props.styles,
      components = props.components,
      isCreatable = props.isCreatable,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var ASelectComponent = isCreatable ? _creatable.default : _reactSelect.default;
  return /*#__PURE__*/_react.default.createElement(ASelectComponent, (0, _extends2.default)({
    styles: _objectSpread(_objectSpread({}, _styles.styles), stylesProp),
    theme: themeProp || (0, _styles.getTheme)(),
    components: _objectSpread({
      ValueContainer: _valueContainer.ValueContainer,
      DropdownIndicator: _dropdownIndicator.DropdownIndicator,
      Menu: _menu.Menu,
      Control: _control.Control
    }, components)
  }, rest));
};

exports.SecondarySelect = SecondarySelect;
var menuPlacement = ['auto', 'bottom', 'top'];
SecondarySelect.modes = {
  menuPlacement: menuPlacement
};
SecondarySelect.propTypes = {
  /* component logic props */
  theme: _propTypes.func,
  styles: _propTypes.object,
  components: _propTypes.object,

  /* styling modificators */
  menuPlacement: (0, _propTypes.oneOf)(menuPlacement),
  isCreatable: _propTypes.bool
  /* classes */

};
SecondarySelect.defaultProps = {
  theme: null,
  styles: {},
  components: {},
  menuPlacement: 'auto',
  isCreatable: false
};